export const FILE_BASE = process.env.FILE_BASE || ''
export const API_BASE = process.env.API_BASE || '/api'
export const isProduction = process.env.NODE_ENV !== 'production'
